import React from 'react';
import PropTypes from 'prop-types';
import Dialog, { withMobileDialog } from 'material-ui/Dialog';
import InvestorKycForm from './InvestorKycForm';

const InvestorKycDialog = ({
  fullScreen,
  open,
  handleClose,
  request,
  title,
  submitText,
  offerId,
}) => (
  <div>
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <InvestorKycForm
        request={request}
        title={title}
        handleClose={handleClose}
        submitText={submitText}
        offerId={offerId}
      />
    </Dialog>
  </div>
);

InvestorKycDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  request: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  offerId: PropTypes.string.isRequired,
  submitText: PropTypes.string,
};

InvestorKycDialog.defaultProps = {
  submitText: 'Submit',
};

export default withMobileDialog({
  breakpoint: 'xs',
})(InvestorKycDialog);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/InvestorKyc/InvestorKycDialog.js